import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

import { ROUTES } from 'config/routes';
import { authSelector } from 'store/selectors';
import CurrentUserContext from 'contexts/CurrentUserContext';
import { isDevEnvironment } from 'utils/environment';

const AuthRoute = ({ component: Component, permissions, devOnly, render, ...rest }) => {
  const token = useSelector(authSelector).token;
  const fallback = ROUTES.LOGIN;
  const { hasPermission } = useContext(CurrentUserContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!token) {
          return <Redirect to={{ pathname: fallback }} />;
        }
        if (devOnly && !isDevEnvironment()) {
          return <div>404</div>;
        }
        if (permissions && !hasPermission(permissions)) {
          return <div>404</div>;
        }
        return Component ? <Component {...props} /> : render && render();
      }}
    />
  );
};

export default AuthRoute;
